import { CsvFileContext } from 'contexts/CsvContext'
import { useContext } from 'react'

const useCsvData = () => {
  const { csvData, setCsvData } = useContext(CsvFileContext)
  return { csvData, setCsvData }
}

export default useCsvData
